import {Record} from 'immutable';
import validateRequiredProps from 'utils/validateRequiredProps';

export const defaultSkillGoal = 75;

export function validate(detail) {
  return validateRequiredProps(
    detail,
    detail.isSkillBased ? ['skillId', 'skillBaseline', 'skillGoal'] : ['custom']
  );
}

export type ContentDetailId = number;

export default class CoachingContentDetail extends Record({
  id: undefined,
  skillId: undefined,
  skillName: undefined,
  skillBaseline: 0,
  skillGoal: undefined,
  custom: undefined,
  isSkillBased: false,
}) {
  readonly id: ContentDetailId;
  readonly skillId?: number;
  readonly skillName?: string;
  readonly skillBaseline?: number;
  readonly skillGoal?: number;
  readonly custom?: string;
  readonly isSkillBased: boolean;

  constructor(object: Partial<CoachingContentDetail> = {}) {
    object = object.toJS ? object.toJS() : object;
    super({
      isSkillBased: object.custom === null || object.custom === undefined,
      ...object,
    });
  }
}

export const nonSkillRelated = new CoachingContentDetail({
  custom: 'Non-Skill Related',
});
